module.exports = __webpack_public_path__ + "media/images/avatar_male4-ce79858e1cfdc235abaae86a23b94097.png";